export const LOGIN_PAGE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.ENVIROMENT === 'dev'
      ? 'https://m.dev.music-flo.com/member/auth/external?request_service=PICKA&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Flogin%2Fbridge&state=1&client_id=o7noeydkli8syvl07tpetu84iulwx7o8'
      : 'https://m.qa.music-flo.com/member/auth/external?request_service=PICKA&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Flogin%2Fbridge&state=1&client_id=4w6szlyfhr6lh63vrinuf4pwsuz8l8e3'
    : (process.env.LOGIN_URL ?? '')

export const NOTICE_PAGE_URL = {
  hosoo: 'https://candle-dugong-577.notion.site/_-23a4dc0751c78045b33bcacf60b3c35f',
  loopy: 'https://candle-dugong-577.notion.site/_-21e4dc0751c78015b37feb3c0d682fb1?',
  saryeonghwa: 'https://candle-dugong-577.notion.site/_-2a24dc0751c7803dbcccf31402276195',
}

export const FAQ_PAGE_URL = {
  hosoo: 'https://www.notion.so/_-23a4dc0751c78016bcd9d0d37f7c3fc2',
  loopy: 'https://candle-dugong-577.notion.site/_-21e4dc0751c78001a390c0343bc4b153?',
  saryeonghwa: 'https://candle-dugong-577.notion.site/_-2a24dc0751c780389a11c828112e778d?',
}
